<template>
    <div style="background: #f8f8f8;height:100%">
        <Headers :title="title" />
        <van-row style="padding:0 .28rem .28rem .28rem">
            <van-col  class="exhibitior-wrap"  v-for="(item, index) in holdingData" :key="index" span="8" @click="goProductDetaile(item.id)">
                <template>
                    <div class="exhibitior-wrap-img">
                        <img class="productImg" :src="item.product.cn.main_image[0].url" alt="" />
                    </div>
                    <div class="exhibitior-wrap-title">
                        <span class="exhibitior-wrap-title-name">{{item.product.cn.name}}</span>
                        <div class="palce-store">
                            <div v-if="item.is_store == 0" class="store"  @click.stop="collect(item)">
                                <img class="store-icon" src="~statics/mobileShouye/unstore.png" alt="">
                                <span class="store-name">{{$t('detail').collect}}</span>
                            </div>
                            <div v-else class="store" @click.stop="cancelCollect(item)">
                                <img class="store-icon"  src="~statics/mobileShouye/store.png" alt="">
                                <span class="store-name">{{$t('detail').uncollect}}</span>
                            </div>
                        </div>
                    </div>
                </template>
            </van-col>
        </van-row>
    </div>
</template>

<script>
import Headers from "../mobileExhibition/components/Headers";
// import Footers from "./components/Footers";
import { mapState } from "vuex";
import api from "@/api";

export default {
    
    data(){
        return{
            holdingData: [
            ],
            list: [],
            loading: false,
            finished: false,
            // title: '产品介绍',
            company_id: null,
            exhibition_id: null,
            product_tempt_id: null
        }
    },
    computed: {
        language(){
            return localStorage.getItem('language') || 'zh'
        },
        title(){
            return this.language == 'zh' ? '产品介绍' : 'Product introduction'
        },
        ...mapState(["userInfo","language"]),
    },
    created() {
        this.company_id = this.$route.query.company_id
        this.exhibition_id = this.$route.query.exhibition_id
        this.getExhibitionProduct()
    },
    mounted(){
    },
    methods: {
        goProductDetaile(_id){
            this.$router.push({
                path: '/mobileAboutProductDetail',
                query: {
                    company_id: this.company_id,
                    exhibition_id: this.exhibition_id,
                    exhibition_product_id: _id
                }
            })
        },
        onLoad() {
            // 异步更新数据
            // setTimeout 仅做示例，真实场景中一般为 ajax 请求
            setTimeout(() => {
                for (let i = 0; i < 10; i++) {
                this.list.push(this.list.length + 1);
                }

                // 加载状态结束
                this.loading = false;

                // 数据全部加载完成
                if (this.list.length >= 40) {
                this.finished = true;
                }
            }, 1000);
        },
        collect(item) {
            if(!this.userInfo.id) {
                this.$notice({ type: 'danger', message: '请先登录后收藏' });
                return
            }else{
                api.isCollectProduct({
                    exhibition_product_id: item.id
                }).then((res) => {
                    console.log(res);
                    if (res.res == 1) {
                        item.is_store = 1;
                        this.$notify({ type: 'success', message: '收藏成功' });
                    }
                });
            }
            
        },
        cancelCollect(item) {
            if(!this.userInfo.id) {
                this.$notice({ type: 'danger', message: '请先登录后收藏' });
                return
            }else{
                api.noCollectProduct({
                    exhibition_product_id: item.id
                }).then((res) => {
                    console.log(res);
                    if (res.res == 1) {
                        item.is_store = 0;
                        this.$notify("取消收藏");
                    }
                });
            }
        },
        // 获取展台商品列表
        getExhibitionProduct() {
            api.getExhibitionProduct({
                exhibition_id: this.exhibition_id,
                company_id: this.$route.query.company_id
                // exhibition_id: 21,
                // company_id: 903
            }).then((res) => {
                if (res.res == 1) {
                    console.log(res.list)
                    if (!res.list || !res.list.length) {
                        this.$notify({ type: 'warning', message: this.$t("tips").noProduct });
                        return;
                    }      
                    this.holdingData = res.list;
                }
            });
        }
    },
    components: {
        Headers
    },
}
</script>

<style lang="scss" scoped>
/deep/ .van-notice-bar__content{
    line-height: .32rem;
    color: #ffffff;
    opacity: 1;
    font-size: 12px
}
/deep/ .van-notice-bar__left-icon{
    color: #fff;
}
/deep/ .van-notice-bar__right-icon{
    color: #fff;
}
/deep/ .van-nav-bar__title{
    color: #fff;
}
/deep/ .van-hairline--bottom{
    background: #194b96;
}
/deep/ .van-icon-search{
    color: #fff;
}
.exhibitior-wrap{
    &:nth-child(odd){
        margin: .16rem .14rem .16rem 0;
    }
    &:nth-child(even){
        margin: .16rem 0;
    }
    height: 6.66rem;
    width: 3.4rem;
    background: #fff;
    border-radius: 6px;
    .exhibitior-wrap-img{
        width: 3.4rem;
        height: 5.36rem;
        opacity: 1;
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
            max-width: 100%;
            max-height: 5.36rem;
            object-fit: contain;
            padding: .08rem;
        }
    }
    .exhibitior-wrap-title{
        display: flex;
        flex-direction: column;
        height: 1.3rem;
        margin: .24rem .26rem .24rem .20rem;
        .exhibitior-wrap-title-name{
            color: #333333;
            line-height: .4rem;
            height: .4rem;
            font-size: 14px;
            overflow: hidden; 
            white-space: nowrap; 
            text-overflow: ellipsis;
        }
        .palce-store{
            display: flex;
            justify-content: space-between;
            margin-top: .12rem;
            .store{
                display: flex;
                .store-icon{
                    width: .24rem;
                    height: .24rem;
                }
                .store-name{
                    line-height: .3rem;
                    color: #999;
                    font-size: 12px;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/mobileAboutProduct/index.vue